var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"web_bottom_btn",style:({backgroundColor: ("" + (_vm.options.style.bgColor)),color: ("" + (_vm.options.style.color))}),on:{"click":_vm.handleClieck}},[_vm._v(_vm._s(_vm.options.data.text))])}
var staticRenderFns = []

export { render, staticRenderFns }